import { DiscountType, IDate, UUID } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { Awaited } from '@avantstay/backoffice-core'

import finance from '@/services/arriere/modules/finance'

import { HomeObject } from './pricingTapeChart.types'

export type RevenueDiscount = Awaited<ReturnType<typeof finance.getDiscountList>>[number]
export interface DiscountValueMap {
  [key: string]: RevenueDiscount
}

export interface DiscountUnsavedChangesValueMap {
  [key: string]: DiscountTapeChartChange
}
export interface HomesGroupedByDiscounts {
  WEEKLY: { [key: number]: RevenueDiscount[] }
  MONTHLY: { [key: number]: RevenueDiscount[] }
}

export interface HomesMap {
  [key: string]: Omit<HomeObject, 'floorRate' | 'isOffboarded' | 'rateByMonth'>
}

export interface DiscountTapeChartChange {
  homeId: string
  homeName: string
  regionId?: string
  regionName?: string
  weeklyDiscountByMonth: number[]
  monthlyDiscountByMonth: number[]
  weeklyDiscount: number
  monthlyDiscount: number
  weeklyDiscountByMonthDisplay?: Array<number | undefined>
  monthlyDiscountByMonthDisplay?: Array<number | undefined>
  month: string
}

export interface DiscountTapeChartUnsavedChangeDisplay {
  month: string
  monthValue: number | undefined
  weekValue: number | undefined
  previousMonthValue: number
  previousWeeklyValue: number
}

export enum DiscountBulkUpdateTypes {
  increase = 'increase',
  decrease = 'decrease',
  reset = 'reset',
  fixed = 'fixed',
}

export interface BulkUpdatePayload {
  weekValue?: number
  monthValue?: number
  bulkEditType?: DiscountBulkUpdateTypes
}

export interface DiscountHistoryChange {
  discountType: DiscountType
  previousValue: number
  newValue: number
  updatedAt: IDate
  author: { name: string }
}

export interface GetDiscountListProps {
  propertyName?: string
  seasonGroupIds?: UUID[]
  discountMin?: number
  discountMax?: number
}

export interface DiscountUpdateInput {
  homeId: UUID
  weeklyDiscount?: number
  monthlyDiscount?: number
  weeklyDiscountByMonth?: number[]
  monthlyDiscountByMonth?: number[]
}
